export function decorateLinkWithGAParameters(url: string): string {
  if (typeof window !== 'undefined' && window.dfAppendGALinkParam) {
    url = window.dfAppendGALinkParam(url)
  }
  return url
}
